import React from 'react';
import SweetAlert from "react-bootstrap-sweetalert";

const AlertError = (props) => {
  return (
    <SweetAlert
      error
      style={{ display: "block", marginTop: "-100px" }}
      title="Error"
      onConfirm={() => props.hideAlert()}
      onCancel={() => props.hideAlert()}
      confirmBtnBsStyle="danger"
      confirmBtnText="Aceptar"
    >
      {props.message}
    </SweetAlert>
  );
}

export default AlertError;



// WEBPACK FOOTER //
// ./src/views/Components/AlertError.jsx